import { Helper } from "../util/helper.js";
import { TextBox } from "./textBox.js";
import { ComponentHelper } from "../util/componentHelper.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react";
export class HiddenMemo extends React.Component<HiddenMemoProps, any>{
    private _factory = ComponentHelper.createFactory();
    constructor(props) {

        super(props);
        this.state = {
            onHover: false,
            showMemo: false
        }
    }
    private _gettextBoxMemoProps = () => {
        const props = this._factory.getDefaultTextBoxProps();
        props.field.readOnly = true;
        props.value = this.props.value;
        props.field.triggerOnChange = true;
        props.field.model = this.props.field.model;
        props.field.multiLine = true;
        props.disabled = true;
        return props;
    }
    onHover = () => {
        this.setState({ ...this.state, onHover: true });
    }

    onHoverLeft = () => {
        this.setState({ ...this.state, onHover: false });
    }
    private showMemo = () => {
        this.setState({ ...this.state, showMemo: !this.state.showMemo });
    }
    render() {
        const linkStyle: React.CSSProperties = {
            fontSize: "large",
            marginTop: "10px",
            color: this.state.onHover ? "var( --primary-color)" : "#c9c9c9"
        }
        // vom Link
        let linkText = "";
        if (this.state.showMemo) {
            linkText = Helper.getTranslation("WebSMS.DataExchangeModule.ExecuteTemplate.Less");
        } else {
            linkText = Helper.getTranslation("WebSMS.DataExchangeModule.ExecuteTemplate.More");
        }
        return (<>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <a onClick={this.showMemo} onMouseOver={this.onHover} onMouseLeave={this.onHoverLeft} style={linkStyle}>{linkText}</a>
            </div>
            {this.state.showMemo ?
                <div style={{ marginTop: '10px' }} id="protUebersicht">
                    <TextBox{...this._gettextBoxMemoProps()} > </TextBox>
                </div>
                : null
            }
        </>);
    }
};
export interface HiddenMemoProps extends BaseComponentProps {
    field: BaseField;
    value: any;
}